import type { ReactNode } from 'react';
import './Card.css';

interface CardProps {
  children: ReactNode;
  featured?: boolean;
  className?: string;
}

export function Card({ children, featured = false, className = '' }: CardProps) {
  return (
    <div className={['card', featured ? 'card--featured' : '', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
